'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

var _Step = require('./Step.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderChild = function renderChild(props, child) {
  var active = props.active,
      completed = props.completed,
      disabled = props.disabled,
      visited = props.visited;


  return typeof child === 'string' ? child : _react2.default.cloneElement(child, (0, _assign2.default)({
    active: active,
    completed: completed,
    disabled: disabled,
    visited: visited
  }, { disabled: (0, _objectResolvePath2.default)(child.props, 'disabled') || disabled }, child.props));
};

var Step = exports.Step = function Step(props) {
  return _react2.default.createElement(
    'div',
    {
      className: props.className + ' step',
      onClick: !props.disabled ? props.onClick : undefined },
    _react.Children.map(props.children, renderChild.bind(null, props)),
    _react2.default.createElement('div', { className: 'progressIndicator' })
  );
};

Step.propTypes = {
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className,
   * but it will be merged with the glamorous className if you do
   */
  children: _propTypes2.default.node,
  /**
   * Whether a step is completed or not.  Non-Linear steps can take a completed prop, which
   * expects a boolean.  If the stepper is Linear, completion is handled internally.
   */
  completed: _propTypes2.default.bool, // eslint-disable-line
  /**
   * The children of the component, is generally and instance of the Step component
   */
  className: _propTypes2.default.string,
  /**
   * Whether the Step is disabled, prevents click event and provides appropriate styles.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Function to fire upon click
   */
  onClick: _propTypes2.default.func
};

exports.default = (0, _glamorous2.default)(Step)(_Step.defaultStyle, _Step.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Step/Step.js
// module id = 627
// module chunks = 0